import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Layout } from "pages/Reprocess/models";

interface InitialState {
  layout: Layout;
  isReprocessSingleBatchToNIBSSModalOpen: boolean;
}

const initialState: InitialState = {
  isReprocessSingleBatchToNIBSSModalOpen: false,
  layout: { title: "", function: "", path: "" },
};

const reprocessSlice = createSlice({
  name: "data-generation",
  initialState: initialState,

  reducers: {
    updateLayout: (state, action: PayloadAction<Layout>) => {
      state.layout = action.payload;
    },

    setIsReprocessSingleBatchToNIBSSModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isReprocessSingleBatchToNIBSSModalOpen = action.payload;
    },
  },
});

export default reprocessSlice.reducer;
export const { updateLayout, setIsReprocessSingleBatchToNIBSSModalOpen } = reprocessSlice.actions;
